module.exports = __webpack_public_path__ + "img/fb-i.c4ac4473.svg";